import makeAsync from "@kiwicom/frontend-common/utils/makeAsync"
import Loading from "@kiwicom/frontend-common/components/Loading/Loading"

export const AccountBooking = makeAsync(
  () =>
    // @ts-expect-error: Flow to TS migration.
    import(
      /* webpackChunkName: "async/AccountBooking" */ "../scenes/AccountBooking/AccountBooking"
    ),
  {
    // @ts-expect-error: Flow to TS migration.
    Loader: Loading,
    lazy: true,
  },
)
